import React from 'react';

const NoLocationSVG: React.FC<React.SVGProps<SVGSVGElement>> = ( { ...props } ) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="2 2 20 20"
      strokeWidth="1.5"
      stroke="currentColor"
      {...props}
    >
      <g>
        <path d="M19 10.2C19 14 15.5 17.4 12 21C8.5 17.4 5 14 5 10.2C5 6.2 8 3 12 3C16 3 19 6.2 19 10.2Z" />
        <path d="M9 7L15 13M15 7L9 13   M19 10.2C19 14 15.5 17.4 12 21C8.5 17.4 5 14 5 10.2C5 6.2 8 3 12 3C16 3 19 6.2 19 10.2Z"
          strokeWidth="0.9" strokeLinecap="round" strokeLinejoin="round" />
      </g>
    </svg>
  );
};

export { NoLocationSVG };
